import {
  Bell,
  FileText,
  Inbox,
  Landmark,
  Mail,
  Newspaper,
  Receipt,
  ScrollText,
  Tag,
  User,
  type LucideIcon,
} from 'lucide-react'
import type { InboxCategoryColor } from '@/features/inbox/types'

const ICONS: Record<string, LucideIcon> = {
  FileText,
  Receipt,
  Landmark,
  ScrollText,
  User,
  Newspaper,
  Bell,
  Inbox,
  Mail,
  Tag,
}

export function categoryIcon(name: string | null | undefined): LucideIcon {
  return (name && ICONS[name]) || Tag
}

const ACCENT: Record<InboxCategoryColor, string> = {
  primary: 'border-l-4 border-l-primary',
  brand: 'border-l-4 border-l-primary',
  info: 'border-l-4 border-l-info',
  success: 'border-l-4 border-l-success',
  warning: 'border-l-4 border-l-warning',
  secondary: 'border-l-4 border-l-border',
}

export function categoryAccent(color: InboxCategoryColor | null | undefined): string {
  return (color && ACCENT[color]) || ACCENT.secondary
}
